const $linksmenu = document.querySelectorAll('.nav-menu .link')
const $inputCheckbox = document.querySelector('.wrapper-navigation .input')

$linksmenu.forEach(link => link.addEventListener('click', checkboxed))

function checkboxed () {
  $inputCheckbox.checked = false
}
